<template lang="pug">
  .cashback-banner-v2(v-if="bannerList.length")
    .banner-item(
      v-for="(item, index) in bannerList"
      :key="index"
      @click="handleBannerClick(item, index)"
      v-platform-expose="{ handler: handleBannerExpose, data: item }"
    )
      img.banner-img(:src="item.imageUrl" alt="")
</template>

<script>
import { handleChannelJump } from '../../../utils';
import SPM from '../../../common/spm';

export default {
  name: 'CashbackBannerV2',
  props: {
    data: {
      type: Object,
      default: null,
    },
    // 位置：top-顶部，button-底部（埋点 bannerPosition 字段值，按埋点约定使用 button 而非 bottom）
    position: {
      type: String,
      default: '',
    },
  },
  inject: ['cashbackStyleVersion', 'getStyleVersion'],
  computed: {
    bannerList() {
      const list = (this.data && this.data.bannerDataList) || [];
      return list.length > 0 ? [list[0]] : [];
    },
  },
  methods: {
    handleBannerClick(item) {
      handleChannelJump(item);
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_banner_new',
        businessInfo: {
          bannerType: 2,
          bannerPosition: this.position,
          clk_url: item?.linkUrl || item?.originUrl || item?.link || '',
          ext: '',
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
    },
    handleBannerExpose(_entry, item) {
      SPM.moduleExpose({
        moduleId: 'Welfare_onlineretailers_banner_new',
        contentId: 'Welfare_onlineretailers_banner_new',
        exposureTimes: 1,
        businessInfo: {
          bannerType: 2,
          bannerPosition: this.position,
          clk_url: item?.linkUrl || item?.originUrl || item?.link || '',
          ext: '',
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cashback-banner-v2 {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .banner-item {
    flex: 1;
    overflow: hidden;

    .banner-img {
      width: 100%;
      vertical-align: bottom;
    }
  }
}
</style>
